export const LorenImageConstants = {
    defaultImage: '/icon-128x128.png'
};
